import { StatusPillVariant } from '../../../../shared/ui/status-pill/status-pill.component';
import { PrestamosModel } from '../../../../modules/finanzas/prestamos/prestamos.model';
import { roundAmount } from '../../../../shared/round-amount';

export const LOAN_DURATION_SHORT = 1;
export const LOAN_DURATION_LONG = 2;

export const LOAN_SETTLEMENT_LABELS: Record<number, string> = {
  1: 'Mensual',
  2: 'Bimensual',
  3: 'Trimestral',
  4: 'Semestral',
  5: 'Anual',
};

export interface LoanRow extends PrestamosModel {
  descripcion: string;
  amortizado: number;
  percent: number;
  __expanded?: boolean;
}

export type LoanOperationKind = 'constitution' | 'shortTermDebt' | 'installment';

export interface LoanOperationDialogData {
  kind: LoanOperationKind;
  loan: LoanRow;
  editUid?: string;
}

export interface LoanAttachmentDialogData {
  loan: LoanRow;
}

export function roundMoney(value: number): number {
  return roundAmount(value);
}

export function stripLoanConcept(concept: string, loan: PrestamosModel): string {
  const text = concept || '';
  const head = ((loan && loan.numero) || '') + ' - ';
  return text.startsWith(head) ? text.substring(head.length) : text;
}

export function loanDurationLabel(duration: number): string {
  if (duration === LOAN_DURATION_SHORT) return 'Corto plazo';
  if (duration === LOAN_DURATION_LONG) return 'Largo plazo';
  return 'Sin duración';
}

export function loanDurationVariant(duration: number): StatusPillVariant {
  if (duration === LOAN_DURATION_SHORT) return 'info';
  if (duration === LOAN_DURATION_LONG) return 'neutral';
  return 'warning';
}

export function loanHasFile(loan: PrestamosModel): boolean {
  return !!loan && !!loan.filesPrestamosUid && loan.filesPrestamosUid !== '00000000-0000-0000-0000-000000000000';
}

export function toLoanRow(loan: PrestamosModel, expanded: boolean): LoanRow {
  const initial = roundMoney(loan.importeInicial);
  const pending = roundMoney(loan.importePendiente);
  const amortizado = roundMoney(Math.max(0, initial - pending));
  const percent = initial > 0 ? Math.min(100, Math.max(0, (amortizado / initial) * 100)) : 0;
  const parts = [loan.entidad, loan.numero].filter(Boolean);
  return {
    ...loan,
    descripcion: parts.join(' · '),
    amortizado,
    percent,
    __expanded: expanded,
  };
}

export interface LoanListFilter {
  page: number;
  pageSize: number;
  search: string;
  sortField: string;
  sortDirection: string;
}

export interface LoanListSummary {
  initialAmount: number;
  outstandingAmount: number;
  amortizedAmount: number;
}

export interface LoanListResult {
  items: PrestamosModel[];
  total: number;
  summary: LoanListSummary;
}

export const EMPTY_LOAN_LIST_SUMMARY: LoanListSummary = { initialAmount: 0, outstandingAmount: 0, amortizedAmount: 0 };
